<template>
    <div class="apply-wrap">
        <!-- 申请大类切换卡：切换时销毁重建子组件，各申请表单互不影响 -->
        <div class="cat-tabs">
            <div class="cat-tab" :class="{ active: category === 'shop' }" @click="switchCategory('shop')">
                彩票投注站申请</div>
            <div class="cat-tab" :class="{ active: category === 'manager' }" @click="switchCategory('manager')">
                彩票代表申请</div>
        </div>

        <component :is="curComponent" :key="category" />
    </div>
</template>

<script>
import ShopApply from './components/ShopApply.vue'
import RepresentativeApply from './components/RepresentativeApply.vue'

// 申请大类 -> 对应表单组件
const COMPONENT_MAP = {
    shop: 'ShopApply',        // 彩票投注站申请
    manager: 'RepresentativeApply', // 彩票代表申请
}

export default {
    name: 'TzzBangfuApply',
    components: { ShopApply, RepresentativeApply },
    data() {
        return {
            // 申请大类：shop-彩票投注站申请  manager-彩票代表申请  team-彩票团队申请
            category: 'shop',
        };
    },
    computed: {
        curComponent() {
            return COMPONENT_MAP[this.category]
        },
    },
    methods: {
        switchCategory(val) {
            if (this.category === val) return
            this.category = val
        },
    }
};
</script>

<!-- 非 scoped：公共表单样式需作用于子组件内部，用 .apply-wrap 限定作用域 -->
<style lang="scss">
.apply-wrap {
    position: relative;

    // 申请大类切换卡
    .cat-tabs {
        display: inline-flex;
        margin-bottom: 22px;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        overflow: hidden;

        .cat-tab {
            padding: 10px 30px;
            font-size: 14px;
            color: #606266;
            background: #f5f7fa;
            cursor: pointer;
            border-right: 1px solid #dcdfe6;
            transition: all 0.2s ease;

            &:last-child {
                border-right: none;
            }

            &:hover {
                background: #ecf5ff;
                color: #1565d8;
            }

            &.active {
                background-image: linear-gradient(135deg, #5aa9ff 0%, #1565d8 100%);
                color: #fff;
                font-weight: bold;
            }
        }
    }

    .biaodan {
        position: relative;
    }

    // 旧版上传（仅团队页沿用）：样式限定在 .upItem 内，避免影响 UploadCard 组件的预览图
    .upItem {
        .el-image {
            height: 150px;
        }

        .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            padding: 10px;

            &:hover {
                border-color: #409eff;
            }
        }
    }

    .msg {
        color: #a16222;
        font-size: 15px;
    }
}
</style>
